import { mergeStyles } from '@bulknutrients/bulk-shared-lib/utils';
import type { ReactElement, ReactNode } from 'react';

/**
 * The base paragraph component. To clamp the paragraph to a max number of lines, specify clampedRows.
 *
 * @param children ReactNode;
 * @param clampedRows number;
 * @returns ReactElement;
 */
export function Paragraph({
  children,
  align,
  className = '',
}: {
  children: ReactNode;
  align?: 'left' | 'right' | 'center';
  className?: string;
}): ReactElement {
  const inlineStyle = {
    left: 'text-left',
    right: 'text-right',
    center: 'text-center',
  };

  return (
    <p
      className={mergeStyles(
        className,
        `mx-0 mb-5 mt-2.5 cursor-default text-base ${align ? inlineStyle[align] : ''}`
      )}
    >
      {children}
    </p>
  );
}
